export const AXIS_POINT_LIMIT = 5;



// WEBPACK FOOTER //
// ./src/features/home/components/compare/chart/ChartConstants.js